import { Box, Chip, IconButton } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar, { ToolbarProps } from '@mui/material/Toolbar';
import { PanelLeftCloseIcon, PanelLeftOpenIcon } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import { useRecoilState } from 'recoil';
import { explorerSidebarOpenState } from '~/state/atoms/viewerAtoms';
import AppConfig from '~/utils/appconfig';
import MVisionLogo from '../Logo/MVisionLogo';
import ApplicationQuickMenu from './application-quick-menu';
import ViewerToolbar from './viewer-toolbar';

function ExplorerSidebarToggle() {
    const [explorerOpen, setExplorerOpen] = useRecoilState(
        explorerSidebarOpenState
    );
    return (
        <IconButton onClick={() => setExplorerOpen((state) => !state)}>
            {explorerOpen ? (
                <PanelLeftCloseIcon size={18} />
            ) : (
                <PanelLeftOpenIcon size={18} />
            )}
        </IconButton>
    );
}

export default function Header({ ...toolbarProps }: ToolbarProps) {
    return (
        <AppBar
            elevation={0}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                background: (theme) => theme.palette.background.default,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
        >
            <Toolbar {...toolbarProps} variant="dense" sx={{ display: 'flex' }}>
                <MVisionLogo />
                <Box
                    flexGrow="1"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    ml={2}
                >
                    <Box display="flex" alignItems="center" gap={2}>
                        <ExplorerSidebarToggle />
                        {!AppConfig.clinicalUse && (
                            <Chip
                                variant="outlined"
                                size="small"
                                color="warning"
                                label={
                                    <FormattedMessage id="notForClinicalUse" />
                                }
                            />
                        )}
                    </Box>
                    <ViewerToolbar />
                    <ApplicationQuickMenu />
                </Box>
            </Toolbar>
        </AppBar>
    );
}
